var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"realtime-visitors"},[(_vm.visitors === null)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" "),(_vm.visitors)?_c('span',[_vm._v("\n        "+_vm._s(_vm.visitors)+"\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }